module.exports = __webpack_public_path__ + "img/contentWeb1.50208d46.png";